import React, { Component } from 'react'
import { TextField } from '@material-ui/core'
import { CardElement, injectStripe } from 'react-stripe-elements'

class CardForm extends Component {
  state = {
    coupon: ''
  }

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  render() {
    return (
      <div>
        <CardElement />
      </div>
    )
  }
}

export default injectStripe(CardForm)
